const servicesList = [
	{
		id: 1,
		service: "Haircut",
		price: 100,
		isPressed: false,
	},
	{
		id: 2,
		service: "Hair Straightening",
		price: 200,
		isPressed: false,
	},
	{
		id: 3,
		service: "Hair Colour",
		price: 500,
		isPressed: false,
	},
	{
		id: 4,
		service: "Nails",
		price: 50,
		isPressed: false,
	},
];

export const services = servicesList;
